import React, { useState } from 'react';
import { Overlay, Wrapper } from './styles';

import Hamburger from './Hamburger';
import LangSwitch from './LangSwitch';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

export const Header = () => {
  const [sidebar, toggle] = useState(false);

  return (
    <Wrapper>
      <Overlay sidebar={sidebar} onClick={() => toggle(!sidebar)} />
      <Navbar />
      <LangSwitch mobile />
      <Hamburger sidebar={sidebar} toggle={toggle} />
      <Sidebar sidebar={sidebar} toggle={toggle} />
    </Wrapper>
  );
};
